export const base = {
  white: "#ffffff",
  black: "#000000",
};

export const blue: ColorType = {
  "25": "#ebf3ff",
  "50": "#eaf2ff",
  "100": "#d7e7fe",
  "200": "#c3dbfe",
  "300": "#86b8fd",
  "400": "#5ea0fd",
  "500": "#4a94fc",
  "600": "#2b81fc",
  "700": "#0e71fb",
  "800": "#0356c9",
  "900": "#0244a1",
};

export const gray: ColorType = {
  "25": "#fcfcfd",
  "50": "#f9fafb",
  "100": "#f2f4f7",
  "200": "#eaecf0",
  "300": "#d0d5dd",
  "400": "#98a2b3",
  "500": "#667085",
  "600": "#475467",
  "700": "#344054",
  "800": "#1d2939",
  "900": "#101828",
};

export const red: ColorType = {
  "25": "#fffbfa",
  "50": "#fef3f2",
  "100": "#fee4e2",
  "200": "#fecdca",
  "300": "#fda29b",
  "400": "#f97066",
  "500": "#f04438",
  "600": "#d92d20",
  "700": "#b42318",
  "800": "#912018",
  "900": "#7a271a",
};

export const error = red;

export const greenLight: ColorType = {
  "25": "#FAFEF5",
  "50": "#F3FEE7",
  "100": "#E4FBCC",
  "200": "#D0F8AB",
  "300": "#A6EF67",
  "400": "#85E13A",
  "500": "#66C61C",
  "600": "#4CA30D",
  "700": "#3B7C0F",
  "800": "#326212",
  "900": "#2B5314",
};

export const green: ColorType = {
  "25": "#f6fef9",
  "50": "#edfcf2",
  "100": "#d3f8df",
  "200": "#aaf0c4",
  "300": "#73e2a3",
  "400": "#3ccb7f",
  "500": "#16b364",
  "600": "#099250",
  "700": "#087443",
  "800": "#095c37",
  "900": "#084c2e",
};

export const tutorGreen: ColorType = {
  "25": "#EBFFFD",
  "50": "#D6FFFB",
  "100": "#AEFFF8",
  "200": "#85FEF4",
  "300": "#0BFEEA",
  "400": "#01F4DF",
  "500": "#01DFCD",
  "600": "#01CCBC",
  "700": "#01A295",
  "800": "#017A70",
  "900": "#00514A",
};

export const pink: ColorType = {
  "25": "#FEF6FB",
  "50": "#FDF2FA",
  "100": "#FCE7F6",
  "200": "#FCCEEE",
  "300": "#FAA7E0",
  "400": "#F670C7",
  "500": "#EE46BC",
  "600": "#DD2590",
  "700": "#C11574",
  "800": "#9E165F",
  "900": "#851651",
};

export const orangeDark: ColorType = {
  "25": "#FFF9F5",
  "50": "#FFF4ED",
  "100": "#FFE6D5",
  "200": "#FFD6AE",
  "300": "#FF9C66",
  "400": "#FF692E",
  "500": "#FF4405",
  "600": "#E62E05",
  "700": "#BC1B06",
  "800": "#97180C",
  "900": "#771A0D",
};

export const yellow: ColorType = {
  "25": "#FEFDF0",
  "50": "#FEFBE8",
  "100": "#FEF7C3",
  "200": "#FEEE95",
  "300": "#FDE272",
  "400": "#FAC515",
  "500": "#EAAA08",
  "600": "#CA8504",
  "700": "#A15C07",
  "800": "#854A0E",
  "900": "#713B12",
};

export const purple: ColorType = {
  "25": "#FAFAFF",
  "50": "#F4F3FF",
  "100": "#EBE9FE",
  "200": "#D9D6FE",
  "300": "#BDB4FE",
  "400": "#9B8AFB",
  "500": "#7A5AF8",
  "600": "#6938EF",
  "700": "#5925DC",
  "800": "#4A1FB8",
  "900": "#3E1C96",
};

export const success: ColorType = {
  "25": "#f6fef9",
  "50": "#ecfdf3",
  "100": "#d1fadf",
  "200": "#a6f4c5",
  "300": "#6ce9a6",
  "400": "#32d583",
  "500": "#12b76a",
  "600": "#039855",
  "700": "#027a48",
  "800": "#05603a",
  "900": "#054f31",
};

export const primary: ColorType = {
  "25": "#ebf3ff",
  "50": "#eaf2ff",
  "100": "#d7e7fe",
  "200": "#c3dbfe",
  "300": "#86b8fd",
  "400": "#5ea0fd",
  "500": "#4a94fc",
  "600": "#2b81fc",
  "700": "#0e71fb",
  "800": "#0356c9",
  "900": "#0244a1",
};

export const warning: ColorType = {
  "25": "#fffcf5",
  "50": "#fffaeb",
  "100": "#fef0c7",
  "200": "#fedf89",
  "300": "#fec84b",
  "400": "#fdb022",
  "500": "#f79009",
  "600": "#dc6803",
  "700": "#b54708",
  "800": "#93370d",
  "900": "#7a2e0e",
};

export const grayBlue: ColorType = {
  "25": "#fcfcfd",
  "50": "#f8f9fc",
  "100": "#eaecf5",
  "200": "#d5d9eb",
  "300": "#b3b8db",
  "400": "#717bbc",
  "500": "#4e5ba6",
  "600": "#3e4784",
  "700": "#363f72",
  "800": "#293056",
  "900": "#101323",
};

export const grayCool: ColorType = {
  "25": "#fcfcfd",
  "50": "#f9f9fb",
  "100": "#eff1f5",
  "200": "#dcdfea",
  "300": "#b9c0d4",
  "400": "#7d89b0",
  "500": "#5d6b98",
  "600": "#4a5578",
  "700": "#404968",
  "800": "#30374f",
  "900": "#111322",
};

export const grayModern: ColorType = {
  "25": "#fcfcfd",
  "50": "#f8fafc",
  "100": "#eef2f6",
  "200": "#e3e8ef",
  "300": "#cdd5df",
  "400": "#9aa4b2",
  "500": "#697586",
  "600": "#4b5565",
  "700": "#364152",
  "800": "#202939",
  "900": "#121926",
};

export const grayNeutral: ColorType = {
  "25": "#fcfcfd",
  "50": "#f9fafb",
  "100": "#f3f4f6",
  "200": "#e5e7eb",
  "300": "#d2d6db",
  "400": "#9da4ae",
  "500": "#6c737f",
  "600": "#4d5761",
  "700": "#384250",
  "800": "#1f2a37",
  "900": "#111927",
};

export const grayIron: ColorType = {
  "25": "#fcfcfc",
  "50": "#fafafa",
  "100": "#f4f4f5",
  "200": "#e4e4e7",
  "300": "#d1d1d6",
  "400": "#a0a0ab",
  "500": "#70707b",
  "600": "#51525c",
  "700": "#3f3f46",
  "800": "#26272b",
  "900": "#18181b",
};

export const grayTrue: ColorType = {
  "25": "#fcfcfc",
  "50": "#fafafa",
  "100": "#f5f5f5",
  "200": "#e5e5e5",
  "300": "#d6d6d6",
  "400": "#a3a3a3",
  "500": "#737373",
  "600": "#525252",
  "700": "#424242",
  "800": "#292929",
  "900": "#141414",
};

export const grayWarm: ColorType = {
  "25": "#fdfdfc",
  "50": "#fafaf9",
  "100": "#f5f5f4",
  "200": "#e7e5e4",
  "300": "#d7d3d0",
  "400": "#a9a29d",
  "500": "#79716b",
  "600": "#57534e",
  "700": "#44403c",
  "800": "#292524",
  "900": "#1c1917",
};

export const moss: ColorType = {
  "25": "#fafdf7",
  "50": "#f5fbee",
  "100": "#e6f4d7",
  "200": "#ceeab0",
  "300": "#acdc79",
  "400": "#86cb3c",
  "500": "#669f2a",
  "600": "#4f7a21",
  "700": "#3f621a",
  "800": "#335015",
  "900": "#2b4212",
};

export const teal: ColorType = {
  "25": "#f6fefc",
  "50": "#f0fdf9",
  "100": "#ccfbef",
  "200": "#99f6e0",
  "300": "#5fe9d0",
  "400": "#2ed3b7",
  "500": "#15b79e",
  "600": "#0e9384",
  "700": "#107569",
  "800": "#125d56",
  "900": "#134e48",
};

export const cyan: ColorType = {
  "25": "#f5feff",
  "50": "#ecfdff",
  "100": "#cff9fe",
  "200": "#a5f0fc",
  "300": "#67e3f9",
  "400": "#22ccee",
  "500": "#06aed4",
  "600": "#088ab2",
  "700": "#0e7090",
  "800": "#155b75",
  "900": "#164c63",
};

export const blueLight: ColorType = {
  "25": "#f5fbff",
  "50": "#f0f9ff",
  "100": "#e0f2fe",
  "200": "#b9e6fe",
  "300": "#7cd4fd",
  "400": "#36bffa",
  "500": "#0ba5ec",
  "600": "#0086c9",
  "700": "#026aa2",
  "800": "#065986",
  "900": "#0b4a6f",
};

export const blueDark: ColorType = {
  "25": "#f5f8ff",
  "50": "#eff4ff",
  "100": "#d1e0ff",
  "200": "#b2ccff",
  "300": "#84adff",
  "400": "#528bff",
  "500": "#2970ff",
  "600": "#155eef",
  "700": "#004eeb",
  "800": "#0040c1",
  "900": "#00359e",
};

export const indigo: ColorType = {
  "25": "#f5f8ff",
  "50": "#eef4ff",
  "100": "#e0eaff",
  "200": "#c7d7fe",
  "300": "#a4bcfd",
  "400": "#8098f9",
  "500": "#6172f3",
  "600": "#444ce7",
  "700": "#3538cd",
  "800": "#2d31a6",
  "900": "#2d3282",
};

export const violet: ColorType = {
  "25": "#fbfaff",
  "50": "#f5f3ff",
  "100": "#ece9fe",
  "200": "#ddd6fe",
  "300": "#c3b5fd",
  "400": "#a48afb",
  "500": "#875bf7",
  "600": "#7839ee",
  "700": "#6927da",
  "800": "#5720b7",
  "900": "#491c96",
};

export const fuchsia: ColorType = {
  "25": "#fefaff",
  "50": "#fdf4ff",
  "100": "#fae8ff",
  "200": "#f5d0fe",
  "300": "#f0abfc",
  "400": "#e685f7",
  "500": "#d444f1",
  "600": "#ba24d5",
  "700": "#9f1ab1",
  "800": "#821890",
  "900": "#6f1877",
};

export const rose: ColorType = {
  "25": "#fff5f6",
  "50": "#fff1f3",
  "100": "#ffe4e8",
  "200": "#fecdd6",
  "300": "#fea3b4",
  "400": "#fd6f8e",
  "500": "#f63d68",
  "600": "#e31b54",
  "700": "#c01048",
  "800": "#a11043",
  "900": "#89123e",
};

export const orange: ColorType = {
  "25": "#fefaf5",
  "50": "#fef6ee",
  "100": "#fdead7",
  "200": "#f9dbaf",
  "300": "#f7b27a",
  "400": "#f38744",
  "500": "#ef6820",
  "600": "#e04f16",
  "700": "#b93815",
  "800": "#932f19",
  "900": "#772917",
};

export type ColorType = {
  "25": string;
  "50": string;
  "100": string;
  "200": string;
  "300": string;
  "400": string;
  "500": string;
  "600": string;
  "700": string;
  "800": string;
  "900": string;
};

export type Colors =
  | "blue"
  | "gray"
  | "red"
  | "green"
  | "tutorGreen"
  | "purple"
  | "success"
  | "error"
  | "base"
  | "greenLight"
  | "pink"
  | "orangeDark"
  | "yellow"
  | "primary"
  | "warning"
  | "grayBlue"
  | "grayCool"
  | "grayModern"
  | "grayNeutral"
  | "grayIron"
  | "grayTrue"
  | "grayWarm"
  | "moss"
  | "teal"
  | "cyan"
  | "blueLight"
  | "blueDark"
  | "indigo"
  | "violet"
  | "fuchsia"
  | "rose"
  | "orange";
